import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class StoreCart extends Event {
    eventName = 'oms_storeCart';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Additional Charges
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let locationId = new LocalStorage.CurrentLocation(clientId).getData();
        let cartId = new LocalStorage.CartId(locationId);

        let selectedProducts = new LocalStorage.CartLocation(locationId).getData();

        // request data
        data.endPoint = application_settings.endPoints.storeCart;
        data.method = 'POST';
        data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'store_cart';
        data.publicAuth = (data.is_user_login == false) ? true : false;
        data.data = {
            client_id: clientId,
            location_id: locationId,
            cart_products: btoa(encodeURIComponent(JSON.stringify(selectedProducts))),
            cart_id: cartId.getData()
        };
    
        // send request
        this.sendRequest(data, function (response) {
          if (response) {
            let result = response.data;

            if (result.success && result.data) {
                cartId.setData(result.data.cart_id);
            }

            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });

    }
}

export default StoreCart;